import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './AddWebpageModal.module.scss'
import { AnchorType } from 'screens/Campaign/CampaignContext/AddWebpageModal/AnchorType'
import { useState } from 'react'
import { isUrlValid } from 'hooks/useIsUrlValid'
import { useCreateSource } from 'hooks/queries/workspaces/useCreateSource'
import { Source } from 'types'

interface AddWebpageModalProps {
  onSourceCreated?: (source: Source, saveMedia?: boolean) => Promise<any> | void
  primaryAction?: string
}

export const AddWebpageModal = ({ onSourceCreated, primaryAction = 'Analyze' }: AddWebpageModalProps) => {
  const { closeModal } = useModals()
  const [url, setUrl] = useState('')
  const [saveMedia, setSaveMedia] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const { isValid, errorMessage } = isUrlValid(url.trim())

  const { mutateAsync: createSource, isLoading: isCreatingSource } = useCreateSource()

  const isLoading = isCreatingSource
  const handleAnalyze = async () => {
    setIsDirty(true)

    if (!isValid) return

    const result = await createSource({ url, type: 'Website' })
    await onSourceCreated?.(result.source, saveMedia)

    closeModal()
  }
  const onUrlChange = (newUrl: string) => {
    setUrl(newUrl)
    setIsDirty(false)
  }

  return (
    <Modal.Root size="sm" onPressOutside={closeModal} aria-label="Add Webpage">
      <Modal.Header title="Add Webpage" />
      <Modal.Content>
        <div className={Styles.content}>
          <AnchorType
            withRadioBullet={false}
            errorMessageClassName={Styles.errorMessage}
            checkboxLabel="Save all media on this page (images and videos) for context."
            onCheckboxChange={setSaveMedia}
            isSelected={true}
            placeholder="Paste a link to the webpage"
            onUrlChange={onUrlChange}
            urlInvalid={isDirty && !isValid}
            urlErrorMessage={errorMessage}
            examplesLabel="Examples:"
            value="website"
            labels={['Blog Post', 'Product Page', 'Real estate listing']}
            images={[
              'https://res.cloudinary.com/almanac/image/upload/v1755891561/blaze_assets/virtual_marketer/strategies/Thumb_daypxe.png',
              'https://res.cloudinary.com/almanac/image/upload/v1755891561/blaze_assets/virtual_marketer/strategies/Thumb-1_imjr4j.png',
              'https://res.cloudinary.com/almanac/image/upload/v1755891561/blaze_assets/virtual_marketer/strategies/Thumb-2_mfriyq.png',
            ]}
          />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" size="lg" onPress={handleAnalyze} isDisabled={isLoading}>
            {primaryAction}
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={closeModal} isDisabled={isLoading}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
